import React, { useContext, useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { SecondaryButton, SecondaryCheckbox, TextBox } from '../../../../../../../Core/Controls';
import {
    Button,
    ButtonGroup,
    Checkbox,
    CircularProgress,
    FormControlLabel,
    FormHelperText,
    Grid,
    Hidden,
    IconButton,
    InputLabel,
    Typography
} from '@material-ui/core';
import { FieldWrappper } from './helpers/FieldWrappper';
import { WheelAndTorqueContext } from './WheelRemoveContext';

import { CustomeSignPad } from './helpers/CustomeSignPad';
import { downldWheelRemovalGetDetails, renaultWheelRemovalGetDetails } from './helpers/wheel-services';
import { AppContext } from '../../../../../../../Core/App/PageLevel/AppContextProvider';
import BorderColor from '@material-ui/icons/BorderColor';
import { AppStorage } from '../../../../../../../Core/Basic/storage-service';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';

const useStyles = makeStyles({
    table: {
        minWidth: 400,
        border: '1px solid rgba(0,0,0,0.3) '
    },
    btnCustomCSS: {
        border: '1px solid lightgrey',
        background: 'white',
        borderRadius: 0,
        padding: 5
        // '& :hover': {
        //     padding: 1
        // }
    },
    IconCss: {
        fontSize: 26
    }
});
const StyledTableCell = withStyles((theme) => ({
    head: {
        // backgroundColor: 'rgba(0,0,0,0.01)',
        // color: theme.palette.common.white,
        // border: 'none',
        // borderLeft: '1px solid rgba(0,0,0,0.3 )',
        // borderRight: '1px solid rgba(0,0,0,0.3)',
        border: '1px solid #f5f5f5',
        padding: 5,
        backgroundColor: 'grey',
        color: 'white'
    },
    body: {
        fontSize: 14,
        border: 'none',
        // borderLeft: '1px dashed rgba(0,0,0,0.3)',
        // borderBottom: '1px dashed rgba(0,0,0,0.3)',
        // borderRight: '1px dashed rgba(0,0,0,0.3)',
        padding: '8px'
    }
}))(TableCell);
const StyledTableCellFullWid = withStyles((theme) => ({
    head: {
        // borderBottom: '1px solid #f5f5f5',
        // border: '1px solid rgba(0,0,0,0.03)',
        padding: 1,
        color: 'red'
        // backgroundColor: 'grey'
    }
}))(TableCell);
const StyledTableCellEmpty = withStyles((theme) => ({
    head: {
        border: '1px solid #f5f5f5',
        padding: 5,
        color: 'red',
        backgroundColor: 'grey'
    },
    body: {
        fontSize: 14,
        fontWeight: 600,
        border: 'none',
        // borderBottom: '1px dashed rgba(0,0,0,0.3)',
        // borderRight: '1px dashed rgba(0,0,0,0.3)',
        // borderRight: '1px dashed rgba(0,0,0,0.3)',
        padding: '8px'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        // backgroundColor: 'white'
        // border: 'none'
        '&:nth-of-type(odd)': {
            backgroundColor: '#F6FDFE'
        },
        '&:nth-of-type(even)': {
            backgroundColor: '#FEF7F6'
        }
    }
}))(TableRow);

const WheelRemoval = () => {
    const {
        vehicleDetails,
        setVehicleDetails,
        wheelRemovalState: state,
        setWheelRemovalState: setState,
        headerId,
        DefaultName,
        urlParams,
        fromStep,
        navigateToDashboard,
        isDisabled
    } = useContext(WheelAndTorqueContext);

    // const DefaultName = AppStorage.getName();
    const appContext = useContext(AppContext);
    const hideModal = appContext?.hideModal || appContext?.dialogState?.hideDialog;
    const hideTopNavAndMenu = appContext?.hideTopNavAndMenu;
    const showToast = appContext?.showToast || appContext?.toastState?.showToast;
    const portalSettings = appContext?.portalSettings;

    const classes = useStyles();

    useEffect(() => {
        fromStep && hideTopNavAndMenu && hideTopNavAndMenu();
    }, []);

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setState((st) => {
            return { ...st, [name]: value };
        });
    };
    const handleFieldS = (name, value) => {
        console.log(name, value, 'name,value');
        setState((st) => {
            return { ...st, [name]: value };
        });
    };

    const GetDriverSign = (val) => {
        setState((st) => ({
            ...st,
            ...val
        }));
    };
    const clearSig = (val) => {
        setState((st) => ({
            ...st,
            storedSignature: null,
            signature: null
        }));
    };

    const setDefaultName = () => {
        setState((st) => {
            let newSt = { ...st };
            newSt.createdBy = DefaultName;
            return newSt;
        });
    };

    const CustomWheelRBtn = ({ value, name }) => {
        return (
            <div style={{ margin: 6.5 }}>
                {value !== 1 ? (
                    <IconButton onClick={() => !isDisabled && handleFieldS(name, 1)} className={classes.btnCustomCSS} disabled={isDisabled}>
                        <CloseIcon style={{ color: 'red' }} className={classes.IconCss} />
                    </IconButton>
                ) : (
                    <IconButton onClick={() => !isDisabled && handleFieldS(name, 0)} className={classes.btnCustomCSS} disabled={isDisabled}>
                        <DoneIcon style={{ color: 'green' }} className={classes.IconCss} />
                    </IconButton>
                )}
            </div>
        );
    };

    return (
        <div style={{ padding: 10, position: 'relative' }}>
            <Grid container justifyContent="center" alignItems="center">
                <Grid xs={12}>
                    <Hidden only={['xs', 'sm', 'md']}>
                        <Typography
                            style={{
                                color: '#3f51b5',
                                borderBottom: '2px solid #3f51b5',
                                paddingBottom: '4px',
                                fontWeight: 600,
                                fontSize: '0.95rem',
                                marginBottom: 10,
                                textTransform: 'uppercase',
                                textAlign: 'left'
                            }}
                        >
                            Wheel Removal
                        </Typography>
                        <Grid container spacing={2} alignItems="flex-end" style={{ marginTop: 0 }}>
                            <Grid item xs={12}>
                                <FieldWrappper heading="" isNewCard={true}>
                                    <TableContainer style={{ minHeight: 200 }}>
                                        <Table className={classes.table} aria-label="simple table" stickyHeader>
                                            <TableHead>
                                                <StyledTableRow>
                                                    <StyledTableCellFullWid colSpan={4} align="center">
                                                        <small>The Wheel Positions indicate below have been work upon </small>
                                                    </StyledTableCellFullWid>
                                                </StyledTableRow>
                                            </TableHead>

                                            <TableBody>
                                                <StyledTableRow key={'row.name'}>
                                                    <StyledTableCellEmpty width="20%" component="th" scope="row" align="center">
                                                        STEER AXLES
                                                        {state?.errors?.steerAxles && (
                                                            <FormHelperText error style={{ marginTop: 4, textAlign: 'center', fontSize: '0.75rem' }}>
                                                                {state.errors.steerAxles}
                                                            </FormHelperText>
                                                        )}
                                                    </StyledTableCellEmpty>
                                                    <StyledTableCell width="37%" align="inherit">
                                                        <Grid container spacing={2} justifyContent="flex-start" alignItems="flex-end">
                                                            <Grid item xs={5}>
                                                                <FormHelperText>Nearside</FormHelperText>

                                                                <CustomWheelRBtn type="number" value={state.steerNSAxle1} name="steerNSAxle1" />
                                                                <CustomWheelRBtn type="number" value={state.steerNSAxle2} name="steerNSAxle2" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                    <StyledTableCell width="6%" align="inherit"></StyledTableCell>
                                                    <StyledTableCell width="37%" align="inherit">
                                                        <Grid container spacing={2} justifyContent="flex-end" alignItems="flex-end">
                                                            <Grid item xs={5}>
                                                                <FormHelperText>Offside</FormHelperText>
                                                                <CustomWheelRBtn type="number" value={state.steerOSAxle1} name="steerOSAxle1" />
                                                                <CustomWheelRBtn type="number" value={state.steerOSAxle2} name="steerOSAxle2" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                </StyledTableRow>

                                                <StyledTableRow>
                                                    <StyledTableCellEmpty width="20%" component="th" scope="row" align="center">
                                                        DRIVER TAG AXLES
                                                    </StyledTableCellEmpty>
                                                    <StyledTableCell width="35%">
                                                        <Grid container spacing={1} justifyContent="flex-start" alignItems="center">
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.driverNSOuterAxle1} name="driverNSOuterAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.driverNSOuterAxle2} name="driverNSOuterAxle2" />
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.driverNSInnerAxle1} name="driverNSInnerAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.driverNSInnerAxle2} name="driverNSInnerAxle2" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                    <StyledTableCell width="10%"></StyledTableCell>
                                                    <StyledTableCell width="35%">
                                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.driverOSInnerAxle1} name="driverOSInnerAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.driverOSInnerAxle2} name="driverOSInnerAxle2" />
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.driverOSOuterAxle1} name="driverOSOuterAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.driverOSOuterAxle2} name="driverOSOuterAxle2" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                                <StyledTableRow>
                                                    <StyledTableCellEmpty width="20%" component="th" scope="row" align="center">
                                                        TRAILER AXLES
                                                    </StyledTableCellEmpty>
                                                    <StyledTableCell width="35%">
                                                        <Grid container spacing={1} justifyContent="flex-start" alignItems="center">
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.trailerNSOuterAxle1} name="trailerNSOuterAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.trailerNSOuterAxle2} name="trailerNSOuterAxle2" />

                                                                <CustomWheelRBtn type="number" value={state.trailerNSOuterAxle3} name="trailerNSOuterAxle3" />
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.trailerNSInnerAxle1} name="trailerNSInnerAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.trailerNSInnerAxle2} name="trailerNSInnerAxle2" />

                                                                <CustomWheelRBtn type="number" value={state.trailerNSInnerAxle3} name="trailerNSInnerAxle3" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                    <StyledTableCell width="10%"></StyledTableCell>
                                                    <StyledTableCell width="35%">
                                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.trailerOSInnerAxle1} name="trailerOSInnerAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.trailerOSInnerAxle2} name="trailerOSInnerAxle2" />

                                                                <CustomWheelRBtn type="number" value={state.trailerOSInnerAxle3} name="trailerOSInnerAxle3" />
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.trailerOSOuterAxle1} name="trailerOSOuterAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.trailerOSOuterAxle2} name="trailerOSOuterAxle2" />

                                                                <CustomWheelRBtn type="number" value={state.trailerOSOuterAxle3} name="trailerOSOuterAxle3" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </FieldWrappper>
                            </Grid>
                            {/* <Grid item xs={4} style={{ marginTop: 0 }}>
                                <Typography style={{ fontWeight: 500, textTransform: 'uppercase', marginBottom: 20 }}>WHEEL REMOVAL COMPLETED BY :</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <InputLabel error>
                                            Print Name* &nbsp;
                                            {!state.createdBy && !isDisabled && (
                                                <BorderColor
                                                    onClick={setDefaultName}
                                                    toolTipTitle="Use User Name"
                                                    fontSize="small"
                                                    style={{ marginBottom: -4, cursor: 'pointer' }}
                                                />
                                            )}
                                        </InputLabel>
                                        <TextBox value={state.createdBy} name="createdBy" onChange={handleFieldChange} disabled={isDisabled} />
                                        <FormHelperText error style={{ marginTop: 0 }}>
                                            {state.errors['createdBy']}
                                        </FormHelperText>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <CustomeSignPad
                                            style={{ marginTop: -12 }}
                                            onChange={GetDriverSign}
                                            content={<InputLabel error>Driver Signature*</InputLabel>}
                                            sign={state.storedSignature}
                                            name="signature"
                                            clearSig={clearSig}
                                            disabled={isDisabled}
                                        />
                                        <FormHelperText error style={{ marginTop: 0 }}>
                                            {state.errors['signature']}
                                        </FormHelperText>
                                    </Grid>
                                </Grid>
                            </Grid> */}
                        </Grid>
                    </Hidden>
                    <Hidden only={['lg', 'xl']}>
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12}>
                                <FieldWrappper heading="" isNewCard={true}>
                                    <TableContainer style={{ minHeight: 200 }}>
                                        <Table className={classes.table} aria-label="simple table" stickyHeader>
                                            <TableHead>
                                                <StyledTableRow>
                                                    <StyledTableCellFullWid colSpan={4} align="center">
                                                        <small>The Wheel Positions indicate below have been work upon </small>
                                                    </StyledTableCellFullWid>
                                                </StyledTableRow>
                                            </TableHead>

                                            <TableBody>
                                                <StyledTableRow key={'row.name'}>
                                                    <StyledTableCellEmpty width="20%" component="th" scope="row" align="center">
                                                        STEER AXLES
                                                        {state?.errors?.steerAxles && (
                                                            <FormHelperText error style={{ marginTop: 4, textAlign: 'center', fontSize: '0.75rem' }}>
                                                                {state.errors.steerAxles}
                                                            </FormHelperText>
                                                        )}
                                                    </StyledTableCellEmpty>
                                                    <StyledTableCell width="35%" align="inherit">
                                                        <Grid container spacing={2} justifyContent="flex-start" alignItems="flex-end">
                                                            <Grid item xs={5}>
                                                                <FormHelperText>Nearside</FormHelperText>

                                                                <CustomWheelRBtn type="number" value={state.steerNSAxle1} name="steerNSAxle1" />
                                                                <CustomWheelRBtn type="number" value={state.steerNSAxle2} name="steerNSAxle2" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                    <StyledTableCell width="10%" align="inherit"></StyledTableCell>
                                                    <StyledTableCell width="35%" align="inherit">
                                                        <Grid container spacing={2} justifyContent="flex-end" alignItems="flex-end">
                                                            <Grid item xs={5}>
                                                                <FormHelperText>Offside</FormHelperText>
                                                                <CustomWheelRBtn type="number" value={state.steerOSAxle1} name="steerOSAxle1" />
                                                                <CustomWheelRBtn type="number" value={state.steerOSAxle2} name="steerOSAxle2" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                </StyledTableRow>

                                                <StyledTableRow>
                                                    <StyledTableCellEmpty width="20%" component="th" scope="row" align="center">
                                                        DRIVER TAG AXLES
                                                    </StyledTableCellEmpty>
                                                    <StyledTableCell width="35%">
                                                        <Grid container spacing={1} justifyContent="flex-start" alignItems="center">
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.driverNSOuterAxle1} name="driverNSOuterAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.driverNSOuterAxle2} name="driverNSOuterAxle2" />
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.driverNSInnerAxle1} name="driverNSInnerAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.driverNSInnerAxle2} name="driverNSInnerAxle2" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                    <StyledTableCell width="10%"></StyledTableCell>
                                                    <StyledTableCell width="35%">
                                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.driverOSInnerAxle1} name="driverOSInnerAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.driverOSInnerAxle2} name="driverOSInnerAxle2" />
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.driverOSOuterAxle1} name="driverOSOuterAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.driverOSOuterAxle2} name="driverOSOuterAxle2" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                                <StyledTableRow>
                                                    <StyledTableCellEmpty width="20%" component="th" scope="row" align="center">
                                                        TRAILER AXLES
                                                    </StyledTableCellEmpty>
                                                    <StyledTableCell width="35%">
                                                        <Grid container spacing={1} justifyContent="flex-start" alignItems="center">
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.trailerNSOuterAxle1} name="trailerNSOuterAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.trailerNSOuterAxle2} name="trailerNSOuterAxle2" />

                                                                <CustomWheelRBtn type="number" value={state.trailerNSOuterAxle3} name="trailerNSOuterAxle3" />
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.trailerNSInnerAxle1} name="trailerNSInnerAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.trailerNSInnerAxle2} name="trailerNSInnerAxle2" />

                                                                <CustomWheelRBtn type="number" value={state.trailerNSInnerAxle3} name="trailerNSInnerAxle3" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                    <StyledTableCell width="10%"></StyledTableCell>
                                                    <StyledTableCell width="35%">
                                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.trailerOSInnerAxle1} name="trailerOSInnerAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.trailerOSInnerAxle2} name="trailerOSInnerAxle2" />

                                                                <CustomWheelRBtn type="number" value={state.trailerOSInnerAxle3} name="trailerOSInnerAxle3" />
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <CustomWheelRBtn type="number" value={state.trailerOSOuterAxle1} name="trailerOSOuterAxle1" />

                                                                <CustomWheelRBtn type="number" value={state.trailerOSOuterAxle2} name="trailerOSOuterAxle2" />

                                                                <CustomWheelRBtn type="number" value={state.trailerOSOuterAxle3} name="trailerOSOuterAxle3" />
                                                            </Grid>
                                                        </Grid>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </FieldWrappper>
                            </Grid>

                            {/* <Grid item xs={12}>
                                <FieldWrappper heading="" isNewCard={true}>
                                    <Grid container>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <InputLabel error>
                                                Print Name*{' '}
                                                {!state.createdBy && !isDisabled && (
                                                    <BorderColor
                                                        onClick={setDefaultName}
                                                        toolTipTitle="Use User Name"
                                                        fontSize="small"
                                                        style={{ marginBottom: -4, cursor: 'pointer' }}
                                                    />
                                                )}
                                            </InputLabel>
                                            <TextBox value={state.createdBy} name="createdBy" onChange={handleFieldChange} disabled={isDisabled} />
                                            <span className="mandatoryfields">{state.errors['createdBy']}</span>
                                        </Grid>
                                        <Grid item xs={12} md={12} lg={12} style={{ width: 'calc(100vw)', height: '163px', marginBottom: '5px' }}>
                                            <CustomeSignPad
                                                onChange={GetDriverSign}
                                                content={<InputLabel error>Driver Signature*</InputLabel>}
                                                sign={state.storedSignature}
                                                name="signature"
                                                clearSig={clearSig}
                                                disabled={isDisabled}
                                            />
                                            <span className="mandatoryfields">{state.errors['signature']}</span>
                                        </Grid>
                                    </Grid>
                                </FieldWrappper>
                            </Grid> */}
                        </Grid>
                    </Hidden>
                </Grid>
            </Grid>
        </div>
    );
};

export default WheelRemoval;
